import type { Components, Theme } from "@mui/material/styles";

export const MuiPagination: Components<Theme>["MuiPagination"] = {
  defaultProps: {
    shape: "rounded",
    color: "primary",
  },
  styleOverrides: {
    ul: ({ theme }) => ({
      gap: theme.spacing(0.5),
    }),
  },
};

export const MuiPaginationItem: Components<Theme>["MuiPaginationItem"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontWeight: 700,
      borderRadius: theme.shape.borderRadius,
      minWidth: 36,
      height: 36,

      "&.Mui-selected": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,

        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
      },
    }),
  },
};
